<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card v-if="studentLanguageDetails">
          <h1 class="mb-2">
            تعیین سطح {{ studentLanguageDetails.studentUserInfo.fullName }} ({{
              studentLanguageDetails.languageInfo.persianTitle
            }})
          </h1>
          <b-row>
            <b-col cols="12" md="9">
              <b-row>
                <template v-if="lessonsList && lessonsList.length > 0">
                  <b-col cols="12" class="mb-2">
                    <h2>انتخاب درس های مورد نظر</h2>
                  </b-col>
                  <b-col
                    cols="12"
                    sm="4"
                    v-for="lesson in sortedLessonList"
                    :key="lesson.priority"
                  >
                    <b-card
                      :border-variant="selectedBorderClass(lesson.id)"
                      style="cursor: pointer"
                      @click="selectLesson(lesson)"
                    >
                      {{ lesson.title }}
                    </b-card>
                  </b-col>
                </template>
                <template v-else-if="lessonsList && lessonsList.length == 0">
                  <b-col cols="12">
                    <p class="text-center">هیچ درسی در این زبان وجود ندارد!</p>
                  </b-col>
                </template>
              </b-row>
            </b-col>
            <b-col cols="12" md="3">
              <div class="mb-2">
                <h3>درس های انتخاب شده</h3>
                <hr />
              </div>
              <draggable
                v-if="selectedLessons && selectedLessons.length > 0"
                :scroll-sensitivity="550"
                handle=".handler"
                :force-fallback="true"
                @end="setNewOrder"
                class="w-full col-span-5"
              >
                <div
                  v-for="lesson in selectedLessons"
                  :key="lesson.priority"
                  class="my-2"
                >
                  <div
                    class="d-flex flex-column flex-lg-row align-items-md-center justify-content-md-between"
                    style="gap: 1rem"
                  >
                    <feather-icon
                      style="
                        cursor: pointer;
                        width: 20px;
                        height: 20px;
                        min-width: 20px;
                        min-height: 20px;
                      "
                      icon="MenuIcon"
                      class="text-primary handler mr-2"
                      size="20"
                    />
                    <p class="mb-0">
                      {{ lesson.title }}
                    </p>
                    <b-form-checkbox
                      v-model="lesson.isRequired"
                      :id="`isRequired${lesson.id}`"
                    >
                      <small> جلسه اجباری </small>
                    </b-form-checkbox>
                    <span class="cursor-pointer" @click="removeLesson(lesson)">
                      <feather-icon
                        icon="Trash2Icon"
                        size="20"
                        class="text-danger"
                      />
                    </span>
                  </div>
                </div>
              </draggable>
              <p v-else class="text-center">درسی انتخاب نشده است.</p>
            </b-col>
          </b-row>
          <div class="d-flex align-items-center justify-content-end">
            <b-button
              @click="sendNewRequest"
              variant="primary"
              :disabled="isRequestBtnDisabled"
              >ثبت نقشه راه</b-button
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { GetASingleStudentLanguage } from "../../../libs/Api/StudentLanguage";
import { GetCourseTypes } from "../../../libs/Api/CourseType";
import { GetAllCourses } from "../../../libs/Api/Course";
import { GetAllLessonsOfCourse } from "../../../libs/Api/Lesson";
import { GetIndependentLessonsList } from "@/libs/Api/IndependentLesson";
import { CreateListBy } from "../../../libs/Api/Roadmap";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Draggable from "vuedraggable";

import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BFormRadio,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
export default {
  async mounted() {
    await this.getASingleStudentLanguage();
    this.getAllLessonsOfSelectedCourse();
    this.getAllCourseTypes();
  },
  data() {
    return {
      studentLanguageDetails: null,
      courseTypes: null,
      selectedCourseType: null,
      courseList: null,
      selectedCourse: null,
      lessonsList: null,
      selectedLessons: [],
      isLoading: false,
    };
  },
  methods: {
    removeLesson(lesson) {
      this.selectedLessons = this.selectedLessons.filter(
        (item) => item != lesson
      );
    },
    async sendNewRequest() {
      let lessonIdArray = [];
      this.selectedLessons.forEach((item) =>
        lessonIdArray.push({
          lessonId: item.id,
          isRequired: item.isRequired,
        })
      );
      let _this = this;
      let createListBy = new CreateListBy(_this);
      createListBy.setRequestParam({
        studentId: _this.studentLanguageDetails.studentUserId,
        languageId: _this.studentLanguageDetails.languageInfo.languageId,
      });
      createListBy.setRequestParamDataObj(lessonIdArray);
      await createListBy.fetch(
        function (response) {
          _this.$toast({
            component: ToastificationContent,
            props: {
              title: "نقشه راه با موفقیت ایجاد شد",
              icon: "FolderPlusIcon",
              variant: "success",
            },
          });
          _this.$router.push("/students/pending-to-specify-level");
        },
        function (error) {
          console.error(error);
        }
      );
    },
    selectedBorderClass(lessonId) {
      if (this.selectedLessons.findIndex((item) => item.id == lessonId) > -1) {
        // Include this lesson
        return "success";
      } else {
        // Does not include this lesson
        return "black";
      }
    },
    selectLesson(lesson) {
      if (
        this.selectedLessons.findIndex((item) => item.id == lesson.id) == -1
      ) {
        this.selectedLessons.push(lesson);
      }
    },
    setNewOrder(event) {
      // Check if any index has changed
      if (event.oldIndex != event.newIndex) {
        this.arrayMove(this.selectedLessons, event.oldIndex, event.newIndex);
      }
    },
    arrayMove(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    },

    async getASingleStudentLanguage() {
      try {
        this.isLoading = true;
        let _this = this;
        let getASingleStudentLanguage = new GetASingleStudentLanguage(_this);
        getASingleStudentLanguage.setRequestParam({
          id: _this.$route.params.id,
        });
        await getASingleStudentLanguage.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.studentLanguageDetails = response.data;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllLessonsOfSelectedCourse() {
      // Here
      let _this = this;
      let getIndependentLessonsList = new GetIndependentLessonsList(_this);
      getIndependentLessonsList.setRequestParamDataObj({
        count: 100,
        pageNumber: 1,
        languageId: _this.studentLanguageDetails.languageInfo.languageId,
      });
      await getIndependentLessonsList.fetch(
        function (response) {
          _this.lessonsList = response.data;
        },
        function (error) {
          console.error(error);
        }
      );
    },
    setSelectedCourse(courseId) {
      if (this.selectedCourse != courseId) {
        this.selectedCourse = courseId;
        this.getAllLessonsOfSelectedCourse();
      }
    },
    isCourseSelected(courseId) {
      if (this.selectedCourse && this.selectedCourse == courseId) {
        return "success";
      } else {
        return "black";
      }
    },
    isCourseTypeSelected(courseTypeId) {
      if (this.selectedCourseType && this.selectedCourseType == courseTypeId) {
        return "success";
      } else {
        return "black";
      }
    },
    setCourseTypeId(courseTypeId) {
      if (this.selectedCourseType != courseTypeId) {
        this.selectedCourseType = courseTypeId;
        this.lessonsList = null;
        this.getAllCourses();
      }
    },
    async getAllCourses() {
      let _this = this;
      let getAllCourses = new GetAllCourses(_this);
      getAllCourses.setRequestParam({
        count: 100,
        pageNumber: 1,
        courseTypeId: _this.selectedCourseType,
        languageId: _this.studentLanguageDetails.languageInfo.languageId,
      });
      await getAllCourses.fetch(
        function (response) {
          if (response.isSuccess) {
            _this.courseList = response.data.courses;
          }
        },
        function (error) {
          console.error(error);
        }
      );
    },
    async getAllCourseTypes() {
      try {
        this.isLoading = true;
        let _this = this;
        let getCourseTypes = new GetCourseTypes(_this);
        getCourseTypes.setParams({
          count: 0,
          pageNumber: 0,
        });
        await getCourseTypes.fetch(
          function (response) {
            if (response.isSuccess) {
              _this.courseTypes = response.data.courseTypes;
            }
          },
          function (error) {
            console.error(error);
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    sortedLessonList() {
      if (this.lessonsList && this.lessonsList.length > 0) {
        return this.lessonsList.sort((a, b) => a.priority - b.priority);
      }
    },
    isRequestBtnDisabled() {
      if (
        !this.selectedLessons ||
        (this.selectedLessons && this.selectedLessons.length < 1)
      ) {
        return true;
      }
    },
  },

  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BFormRadio,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BOverlay,
    Draggable,
  },
};
</script>
<style scoped>
button:disabled {
  background-color: #aaaaaa;
  cursor: not-allowed;
}
</style>
